<div class="consent-approval-container">
  <tui-scrollbar class="box consent-text-wrapper">
    <wo-consent-approval-text/>
  </tui-scrollbar>
  <iss-content-panel [hideHeader]="true">
    <div class="tw-w-full tw-flex tw-items-center tw-gap-[8px] tw-justify-end">
      <button tuiButton appearance="outline" data-e2e="accept consent approval button" [disabled]="requestPending" (click)="onRejectSelected()">
        {{ 'button.reject' | translate }}
      </button>
      <button tuiButton data-e2e="accept consent approval button" [showLoader]="requestPending" [disabled]="requestPending"
              (click)="sendConsentApproval()">
        {{ 'button.accept' | translate }}
      </button>
    </div>
  </iss-content-panel>
</div>
